import { render, staticRenderFns } from "./LearningSuite.vue?vue&type=template&id=3e1d1332&scoped=true"
import script from "./LearningSuite.vue?vue&type=script&lang=js"
export * from "./LearningSuite.vue?vue&type=script&lang=js"
import style0 from "./LearningSuite.vue?vue&type=style&index=0&id=3e1d1332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1d1332",
  null
  
)

export default component.exports